// import {
//     Autocomplete,
//     Box,
//     Button,
//     Checkbox,
//     FormControl,
//     FormControlLabel,
//     Grid,
//     InputLabel,
//     MenuItem,
//     Paper,
//     Select,
//     TextField,
// } from "@mui/material";
// import { toast } from "react-toastify";

// const DetailTabContent = ({
//     productData,
//     setProductData,
//     publicCategory,
//     adminVendor,
//     color,
//     brandOptions,
//     selectedCategoryId,
//     setSelectedCategoryId,
//     selectedSubCategoryId,
//     setSelectedSubCategoryId,
//     onNext
// }) => {

//     const handleChange = (e) => {
//         const { name, value } = e.target;

//         if (name === "gst" && !/^\d*$/.test(value)) return;
//         if (name === "customizationPrice" && !/^\d*$/.test(value)) return;

//         setProductData((prev) => ({
//             ...prev,
//             [name]: value
//         }));
//     };

//     const handleCheckboxChange = (e) => {
//         const { name, checked } = e.target;

//         setProductData((prev) => {
//             if (name === "customizationAllowed") {
//                 return {
//                     ...prev,
//                     [name]: checked,
//                     customizationPrice: checked ? prev.customizationPrice || 0 : 0
//                 };
//             }
//             return { ...prev, [name]: checked };
//         });
//     };

//     const handleNextStep = () => {
//         if (
//             !productData.vendorId ||
//             !productData.title?.trim() ||
//             !productData.description?.trim() ||
//             !productData.brandName?.trim() ||
//             !productData.categoryId ||
//             !productData.subCategoryId ||
//             !productData.productCategoryId ||
//             !productData.colorId
//         ) {
//             toast.error("Please fill all required fields");
//             return;
//         }

//         if (productData.title.length < 3 || productData.title.length > 200) {
//             toast.error("Product title must be 3-200 characters");
//             return;
//         }

//         if (
//             productData.description.length < 3 ||
//             productData.description.length > 2000
//         ) {
//             toast.error("Description must be 3-2000 characters");
//             return;
//         }

//         if (
//             productData.brandName.length < 3 ||
//             productData.brandName.length > 100
//         ) {
//             toast.error("Brand name must be 3-100 characters");
//             return;
//         }
//         console.log("details tab product data : ", productData)

//         onNext();
//     };

//     return (
//         <Paper
//             elevation={0}
//             sx={{
//                 p: { xs: 2, md: 4 },
//                 borderRadius: 3,
//                 backgroundColor: "#fafafa",
//                 border: "1px solid #eee"
//             }}
//         >
//             <Grid container spacing={3}>

//                 {/* Vendor */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Vendor</InputLabel>
//                         <Select
//                             name="vendorId"
//                             value={productData.vendorId}
//                             label="Vendor"
//                             onChange={handleChange}
//                         >
//                             {adminVendor?.vendors?.response
//                                 ?.filter((v) => v?.approved && !v?.isBlocked)
//                                 ?.map((vendor) => (
//                                     <MenuItem key={vendor.id} value={vendor.id}>
//                                         {vendor.name}
//                                     </MenuItem>
//                                 ))}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 {/* Title */}
//                 <Grid item xs={12} sm={6} md={8}>
//                     <TextField
//                         fullWidth
//                         label="Product Title"
//                         name="title"
//                         size="small"
//                         value={productData.title}
//                         onChange={handleChange}
//                     />
//                 </Grid>

//                 {/* Description */}
//                 <Grid item xs={12}>
//                     <TextField
//                         fullWidth
//                         multiline
//                         rows={3}
//                         label="Description"
//                         name="description"
//                         size="small"
//                         value={productData.description}
//                         onChange={handleChange}
//                     />
//                 </Grid>

//                 {/* Category */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Category</InputLabel>
//                         <Select
//                             name="categoryId"
//                             value={productData.categoryId}
//                             label="Category"
//                             onChange={handleChange}
//                         >
//                             {publicCategory?.categories?.response?.map((category) => (
//                                 <MenuItem key={category.id} value={category.id} onClick={() => { setSelectedCategoryId(category.id); setSelectedSubCategoryId(0) }}>
//                                     {category.name}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 {/* SubCategory */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Sub Category</InputLabel>
//                         <Select
//                             name="subCategoryId"
//                             value={productData.subCategoryId}
//                             label="Sub Category"
//                             onChange={handleChange}
//                         >
//                             {publicCategory?.categories?.response
//                                 ?.filter((c) => c.id === selectedCategoryId)
//                                 .flatMap((c) =>
//                                     c.subCategories?.map((sub) => (
//                                         <MenuItem key={sub.id} value={sub.id} onClick={() => { setSelectedSubCategoryId(sub.id) }}>
//                                             {sub.name}
//                                         </MenuItem>
//                                     ))
//                                 )}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 {/* Product Category */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Product Category</InputLabel>
//                         <Select
//                             name="productCategoryId"
//                             value={productData.productCategoryId}
//                             label="Product Category"
//                             onChange={handleChange}
//                         >
//                             {publicCategory?.categories?.response
//                                 ?.filter((c) => c.id === selectedCategoryId)
//                                 .flatMap((c) =>
//                                     c.subCategories
//                                         ?.filter((s) => s.id === selectedSubCategoryId)
//                                         .flatMap((s) =>
//                                             s.productCategories?.map((pc) => (
//                                                 <MenuItem key={pc.id} value={pc.id}>
//                                                     {pc.name}
//                                                 </MenuItem>
//                                             ))
//                                         )
//                                 )}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 {/* Color */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControl fullWidth size="small">
//                         <InputLabel>Color</InputLabel>
//                         <Select
//                             name="colorId"
//                             value={productData.colorId}
//                             label="Color"
//                             onChange={handleChange}
//                         >
//                             {color.colors?.response?.map((item) => (
//                                 <MenuItem key={item.id} value={item.id}>
//                                     {item.name}
//                                 </MenuItem>
//                             ))}
//                         </Select>
//                     </FormControl>
//                 </Grid>

//                 {/* Brand */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <Autocomplete
//                         freeSolo
//                         options={brandOptions || []}
//                         value={productData.brandName || ""}
//                         onChange={(e, val) =>
//                             setProductData((prev) => ({
//                                 ...prev,
//                                 brandName: val || ""
//                             }))
//                         }
//                         onInputChange={(e, val) =>
//                             setProductData((prev) => ({
//                                 ...prev,
//                                 brandName: val || ""
//                             }))
//                         }
//                         renderInput={(params) => (
//                             <TextField {...params} label="Brand Name" size="small" />
//                         )}
//                     />
//                 </Grid>

//                 {/* GST */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <TextField
//                         fullWidth
//                         label="GST (%)"
//                         name="gst"
//                         size="small"
//                         value={productData.gst}
//                         onChange={handleChange}
//                     />
//                 </Grid>

//                 {/* Options Section */}
//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControlLabel
//                         control={
//                             <Checkbox
//                                 name="returnAllowed"
//                                 checked={productData.returnAllowed}
//                                 onChange={handleCheckboxChange}
//                             />
//                         }
//                         label="Return Allowed"
//                     />
//                 </Grid>

//                 <Grid item xs={12} sm={6} md={4}>
//                     <FormControlLabel
//                         control={
//                             <Checkbox
//                                 name="customizationAllowed"
//                                 checked={productData.customizationAllowed}
//                                 onChange={handleCheckboxChange}
//                             />
//                         }
//                         label="Customization Allowed"
//                     />
//                 </Grid>

//                 {productData.customizationAllowed && (
//                     <Grid item xs={12} sm={6} md={4}>
//                         <TextField
//                             fullWidth
//                             name="customizationPrice"
//                             label="Customization Price"
//                             size="small"
//                             value={productData.customizationPrice}
//                             onChange={handleChange}
//                         />
//                     </Grid>
//                 )}

//             </Grid>

//             <Box
//                 display="flex"
//                 justifyContent="flex-end"
//                 mt={4}
//             >
//                 <Button
//                     variant="contained"
//                     size="medium"
//                     sx={{
//                         px: 4,
//                         borderRadius: 2,
//                         textTransform: "none"
//                     }}
//                     onClick={handleNextStep}
//                 >
//                     Save & Continue
//                 </Button>
//             </Box>
//         </Paper>
//     );
// };

// export default DetailTabContent;


import {
    Autocomplete,
    Box,
    Button,
    Checkbox,
    FormControl,
    FormControlLabel,
    Grid,
    InputLabel,
    MenuItem,
    Paper,
    Select,
    TextField,
} from "@mui/material";
import { toast } from "react-toastify";

const DetailTabContent = ({
    productData,
    setProductData,
    publicCategory,
    adminVendor,
    color,
    brandOptions,
    selectedCategoryId,
    setSelectedCategoryId,
    selectedSubCategoryId,
    setSelectedSubCategoryId,
    showFields,
    isEditMode,
    onNext,
}) => {

    // ================= CHANGE HANDLER =================
    const handleChange = (e) => {
        const { name, value } = e.target;

        // Allow decimal GST
        if (name === "gst" && !/^\d*\.?\d*$/.test(value)) return;
        if (name === "customizationPrice" && !/^\d*\.?\d*$/.test(value)) return;

        // 🔥 CATEGORY CHANGE FIX
        if (name === "categoryId") {
            setSelectedCategoryId(value);
            setSelectedSubCategoryId(0);

            setProductData((prev) => ({
                ...prev,
                categoryId: value,
                subCategoryId: "",
                productCategoryId: "",
            }));
            return;
        }

        // 🔥 SUBCATEGORY CHANGE FIX
        if (name === "subCategoryId") {
            setSelectedSubCategoryId(value);

            setProductData((prev) => ({
                ...prev,
                subCategoryId: value,
                productCategoryId: "",
            }));
            return;
        }

        setProductData((prev) => ({
            ...prev,
            [name]: value,
        }));
    };

    // ================= CHECKBOX =================
    const handleCheckboxChange = (e) => {
        const { name, checked } = e.target;

        setProductData((prev) => {
            if (name === "customizationAllowed") {
                return {
                    ...prev,
                    customizationAllowed: checked,
                    customizationPrice: checked ? prev.customizationPrice || 0 : 0,
                };
            }
            return { ...prev, [name]: checked };
        });
    };

    // ================= VALIDATION =================
    const handleNextStep = () => {
        if (
            !productData.title?.trim() ||
            !productData.description?.trim() ||
            !productData.brandName?.trim() ||
            !productData.categoryId ||
            !productData.subCategoryId ||
            !productData.productCategoryId ||
            !productData.colorId
        ) {
            toast.error("Please fill all required fields");
            return;
        }
        if (
            !productData.vendorId && showFields) {
            toast.error("Please select a vendor!")
        }

        if (productData.title.length < 3 || productData.title.length > 200) {
            toast.error("Product title must be 3-200 characters");
            return;
        }

        if (
            productData.description.length < 3 ||
            productData.description.length > 2000
        ) {
            toast.error("Description must be 3-2000 characters");
            return;
        }

        if (
            productData.brandName.length < 2 ||
            productData.brandName.length > 100
        ) {
            toast.error("Brand name must be 2-100 characters");
            return;
        }
        console.log("details tab data ", productData)

        onNext();
    };

    return (
        <Paper
            sx={{
                p: 5,
                borderRadius: 3,
                minHeight: 300
            }}
        >
            <Grid container spacing={3}>

                {/* Vendor */}
                {showFields &&
                    <Grid item xs={12} sm={6} md={4}>
                        <FormControl fullWidth size="small" disabled={isEditMode}>
                            <InputLabel>Vendor</InputLabel>
                            <Select
                                name="vendorId"
                                value={productData.vendorId}
                                label="Vendor"
                                onChange={handleChange}
                            >
                                {adminVendor?.vendors?.response
                                    ?.filter((v) => v?.approved && !v?.isBlocked)
                                    ?.map((vendor) => (
                                        <MenuItem key={vendor.id} value={vendor.id}>
                                            {vendor.name}
                                        </MenuItem>
                                    ))}
                            </Select>
                        </FormControl>
                    </Grid>
                }

                {/* Title */}
                <Grid item xs={12} sm={6} md={Boolean(showFields) ? 8 : 12}>
                    <TextField
                        fullWidth
                        label="Product Title"
                        name="title"
                        size="small"
                        value={productData.title}
                        onChange={handleChange}
                    />
                </Grid>

                {/* Description */}
                <Grid item xs={12}>
                    <TextField
                        fullWidth
                        multiline
                        rows={3}
                        label="Description"
                        name="description"
                        size="small"
                        value={productData.description}
                        onChange={handleChange}
                    />
                </Grid>

                {/* Category */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Category</InputLabel>
                        <Select
                            name="categoryId"
                            value={productData.categoryId}
                            label="Category"
                            onChange={handleChange}
                        >
                            {publicCategory?.categories?.response?.map((category) => (
                                <MenuItem key={category.id} value={category.id}>
                                    {category.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* SubCategory */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Sub Category</InputLabel>
                        <Select
                            name="subCategoryId"
                            value={productData.subCategoryId}
                            label="Sub Category"
                            onChange={handleChange}
                        >
                            {publicCategory?.categories?.response
                                ?.find((c) => c.id === selectedCategoryId)
                                ?.subCategories?.map((sub) => (
                                    <MenuItem key={sub.id} value={sub.id}>
                                        {sub.name}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Product Category */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Product Category</InputLabel>
                        <Select
                            name="productCategoryId"
                            value={productData.productCategoryId}
                            label="Product Category"
                            onChange={handleChange}
                        >
                            {publicCategory?.categories?.response
                                ?.find((c) => c.id === selectedCategoryId)
                                ?.subCategories?.find((s) => s.id === selectedSubCategoryId)
                                ?.productCategories?.map((pc) => (
                                    <MenuItem key={pc.id} value={pc.id}>
                                        {pc.name}
                                    </MenuItem>
                                ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Color */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControl fullWidth size="small">
                        <InputLabel>Color</InputLabel>
                        <Select
                            name="colorId"
                            value={productData.colorId}
                            label="Color"
                            onChange={handleChange}
                        >
                            {color.colors?.response?.map((item) => (
                                <MenuItem key={item.id} value={item.id}>
                                    {item.name}
                                </MenuItem>
                            ))}
                        </Select>
                    </FormControl>
                </Grid>

                {/* Brand */}
                <Grid item xs={12} sm={6} md={4}>
                    <Autocomplete
                        freeSolo
                        options={brandOptions || []}
                        value={productData.brandName || ""}
                        onInputChange={(e, val) =>
                            setProductData((prev) => ({
                                ...prev,
                                brandName: val || "",
                            }))
                        }
                        renderInput={(params) => (
                            <TextField {...params} label="Brand Name" size="small" />
                        )}
                    />
                </Grid>

                {/* GST */}
                <Grid item xs={12} sm={6} md={4}>
                    <TextField
                        fullWidth
                        label="GST (%)"
                        name="gst"
                        size="small"
                        value={productData.gst}
                        onChange={handleChange}
                    />
                </Grid>

                {/* Options Section */}
                <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="returnAllowed"
                                checked={productData.returnAllowed}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Return Allowed"
                    />
                </Grid>

                <Grid item xs={12} sm={6} md={4}>
                    <FormControlLabel
                        control={
                            <Checkbox
                                name="customizationAllowed"
                                checked={productData.customizationAllowed}
                                onChange={handleCheckboxChange}
                            />
                        }
                        label="Customization Allowed"
                    />
                </Grid>

                {productData.customizationAllowed && (
                    <Grid item xs={12} sm={6} md={4}>
                        <TextField
                            fullWidth
                            name="customizationPrice"
                            label="Customization Price"
                            size="small"
                            value={productData.customizationPrice}
                            onChange={handleChange}
                        />
                    </Grid>
                )}

            </Grid>

            <Box display="flex" justifyContent="flex-end" mt={4}>
                <Button
                    variant="contained"
                    sx={{ px: 4, borderRadius: 2, textTransform: "none" }}
                    onClick={handleNextStep}
                >
                    Save & Continue
                </Button>
            </Box>
        </Paper>
    );
};

export default DetailTabContent;